var site;

site = site || {};

(function ($) {
  Drupal.behaviors.ingredientModuleV1 = {
    $formatter: $(),
    isMobile: false,
    attached: false,
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.$formatter = $('.js-ingredients-wrapper', context);

      self.$formatter.each(function () {
        var $thisFormatter = $(this);
        var $ingredientImage = $thisFormatter.find('.js-ingredients-image');
        var $ingredientContent = $thisFormatter.find('.js-ingredients-content');
        var $dotsDiv = $thisFormatter.find('.js-ingredients-carousel-dots');
        var speed = 300;
        var settingsImage = {
          rtl: site.direction.isRTL,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: speed,
          arrows: false,
          dots: false,
          infinite: false,
          swipe: false,
          focusOnSelect: true,
          fade: true,
          asNavFor: '.js-ingredients-content',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                swipe: true,
                dots: true,
                fade: false,
                appendDots: $dotsDiv
              }
            }
          ]
        };
        var settingsContent = {
          rtl: site.direction.isRTL,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: speed,
          arrows: false,
          dots: false,
          focusOnSelect: true,
          variableWidth: true,
          infinite: false,
          asNavFor: '.js-ingredients-image',
          onInit: function () {
            $ingredientContent.find('.slick-slide').not(':first').removeClass('slick-active');
            $ingredientContent.find('.slick-active').addClass('slick-active-selected');
          },
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false
              }
            }
          ]
        };

        $ingredientImage.not('.slick-initialized').slick(settingsImage);
        $ingredientContent.not('.slick-initialized').slick(settingsContent);

        $ingredientContent.off('mouseenter').on('mouseenter', '.slick-slide', _.debounce(function () {
          var index = $(this).index();
          $ingredientImage.slickGoTo(index);
          $ingredientContent.find('.slick-active').removeClass('slick-active');
          $(this).addClass('slick-active');
        }, speed));
        $thisFormatter.off('mouseleave').on('mouseleave', _.debounce(function (event) {
          var $currentSlideSelected = $ingredientContent.find('.slick-active-selected');
          var selectedSlideIndex;
          var $releatedTargetParent = $(event.relatedTarget).closest($thisFormatter);
          if ($releatedTargetParent.length > 0 && $currentSlideSelected.length <= 0) {
            return;
          }
          selectedSlideIndex = $currentSlideSelected.index();
          $ingredientImage.slickGoTo(selectedSlideIndex);
          $ingredientContent.find('.slick-active').removeClass('slick-active');
          $currentSlideSelected.addClass('slick-active');
        }, speed));
        $ingredientContent.once().on('click', '.slick-slide', function() {
          $ingredientContent.find('.slick-slide').removeClass('slick-active-selected');
          $(this).addClass('slick-active-selected');
        });

      });
    }
  };
})(jQuery, window.site || {});
